<template>
  <v-form ref="form">
    <div class="text_field__container">
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.not_null]"
          v-model="data.organization"
          :loading="loading"
          :error="hasError('organization')"
          :error-messages="getError('organization')"
      >
        <template v-slot:label>
          <div class="label__text">
            <span v-if="$vuetify.display.width > 768">Образовательная</span>
            <span v-else>Обр.</span>
             организация
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          type="number"
          :min="9"
          :max="11"
          :rules="[rules.number]"
          v-model="data.class_name"
          :loading="loading"
          :error="hasError('class_name')"
          :error-messages="getError('class_name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Класс
          </div>
        </template>
      </v-text-field>
      <v-select
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          item-title="text"
          item-value="value"
          no-data-text="Нет подходящих данных"
          :items="selectors.olympiads"
          :rules="[rules.not_null]"
          v-model="data.olympiad"
          :loading="loading"
          :error="hasError('olympiad')"
          :error-messages="getError('olympiad')"
      >
        <template v-slot:label>
          <div class="label__text">
            Олимпиада
          </div>
        </template>
      </v-select>
      <div class="check_box__container">
        <v-checkbox
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            v-model="data.is_winner"
            :loading="loading"
            :error="hasError('is_winner')"
            :error-messages="getError('is_winner')"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Являюсь победителем
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            v-model="data.is_prizewinner"
            :loading="loading"
            :error="hasError('is_prizewinner')"
            :error-messages="getError('is_prizewinner')"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Являюсь призером
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
            v-if="getUserStatus.is_active_simplified"
            false-icon="$custom_checkbox"
            class="check__box"
            color="#3254B9"
            @click="simplified = !simplified"
            :loading="loading"
        >
          <template v-slot:label>
            <div class="check__box_text">
              Предоставить полный комплект документов
            </div>
          </template>
        </v-checkbox>
      </div>
    </div>
    <div class="page__subtitle" v-if="schoolchild_age < 18">
      Заполните информацию о представителе
    </div>
    <div class="text_field__container" v-if="schoolchild_age < 18">
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.name]"
          v-model="data.rep_last_name"
          :loading="loading"
          :error="hasError('rep_last_name')"
          :error-messages="getError('rep_last_name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Фамилия
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.name]"
          v-model="data.rep_name"
          :loading="loading"
          :error="hasError('rep_name')"
          :error-messages="getError('rep_name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Имя
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.middle_name]"
          v-model="data.rep_middle_name"
          :loading="loading"
          :error="hasError('rep_middle_name')"
          :error-messages="getError('rep_middle_name')"
      >
        <template v-slot:label>
          <div class="label__text">
            Отчество
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.phone]"
          v-maska:[phone_options]
          v-model="data.rep_phone"
          :loading="loading"
          :error="hasError('rep_phone')"
          :error-messages="getError('rep_phone')"
      >
        <template v-slot:label>
          <div class="label__text">
            Телефон
          </div>
        </template>
      </v-text-field>
      <v-text-field
          class="text__field"
          color="#3254B9"
          base-color="#313743"
          variant="outlined"
          :rules="[rules.email]"
          v-model="data.rep_email"
          :loading="loading"
          :error="hasError('rep_email')"
          :error-messages="getError('rep_email')"
      >
        <template v-slot:label>
          <div class="label__text">
            Электронная почта
          </div>
        </template>
      </v-text-field>
    </div>
    <div class="page__subtitle mt-4">
      Приложите подтверждающие документы
    </div>
    <v-alert class="file__container mb-10" type="info" rounded="lg" max-width="900" color="#376FFE" :closable="true" variant="outlined" :icon="false">
      Требования к загружаемым файлам: не менее 200dpi, не более 5 Мбайт
    </v-alert>
    <div class="page__sub_subtitle">
      Прикрепите 2-3 страницу (разворот с фотографией и ФИО) документа, удостоверяющего вашу личность
    </div>
    <div class="file__container">
      <v-file-input
          class="file__input"
          label="File input"
          variant="outlined"
          prepend-icon=""
          color="#3254B9"
          base-color="#313743"
          accept=".pdf, image/png, image/jpeg"
          :show-size="1000"
          :rules="[rules.file]"
          v-model="data.file1"
          :loading="loading"
          :error="hasError('files')"
          :error-messages="getError('files')"
      >
        <template v-slot:label>
          <div class="d-flex flex-wrap">
            <v-row justify="center" class="file__input_row" no-gutters>
              <v-icon :size="$vuetify.display.width >= 1280 ? 112 : 56">$custom_clip</v-icon>
            </v-row>
            <v-row justify="center" class="file__input_row" no-gutters>
              <div class="file_label__text">
                Выберите файл<span v-if="$vuetify.display.width >= 1280">(.pdf, .png или .jpeg) или перетащите его сюда</span>
              </div>
            </v-row>
          </div>
        </template>
      </v-file-input>
      <div class="page__sub_subtitle" v-if="!simplified">
        Диплом победителя или призёра соответствующей олимпиады
      </div>
      <v-file-input
          v-if="!simplified"
          class="file__input"
          label="File input"
          variant="outlined"
          prepend-icon=""
          color="#3254B9"
          base-color="#313743"
          accept=".pdf, image/png, image/jpeg"
          :show-size="1000"
          :rules="[rules.file]"
          v-model="data.file2"
          :loading="loading"
          :error="hasError('files')"
          :error-messages="getError('files')"
      >
        <template v-slot:label>
          <div class="d-flex flex-wrap">
            <v-row justify="center" class="file__input_row" no-gutters>
              <v-icon :size="$vuetify.display.width >= 1280 ? 112 : 56">$custom_clip</v-icon>
            </v-row>
            <v-row justify="center" class="file__input_row" no-gutters>
              <div class="file_label__text">
                Выберите файл<span v-if="$vuetify.display.width >= 1280">(.pdf, .png или .jpeg) или перетащите его сюда</span>
              </div>
            </v-row>
          </div>
        </template>
      </v-file-input>
    </div>
  </v-form>
  <div class="alert__container" v-if="error">
    <v-alert
        class="error_alert"
        :value="true"
        outline
        :icon="false"
        color="#8f0808"
        variant="outlined"
    >
      {{ error[0] }}
    </v-alert>
  </div>
  <v-btn
      class="btn__next"
      elevation="0"
      :loading="loading"
      @click="validate"
  >
        <span class="btn__next_text">
          ДАЛЕЕ
        </span>
  </v-btn>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import { vMaska } from "maska"

export default defineComponent({
  name: "IndividualInfoSchoolchild",
  mixins: [FormErrorsMixin],
  directives: { maska: vMaska },
  data () {
    return {
      phone_options: {
        mask: "+7 (###) ###-##-##",
        eager: true
      },
      name_options: {
        mask: "A-A",
        tokens: {
          A: { pattern: /^[а-яёА-ЯЁ]*$/, multiple: true },
        }
      },
      data: {
        organization: '',
        class_name: 9,
        olympiad: null,
        is_winner: false,
        is_prizewinner: false,
        rep_last_name: '',
        rep_name: '',
        rep_middle_name: '',
        rep_phone: '',
        rep_email: '',
        file1: undefined,
        file2: undefined,
      },
      loading: false,
      type_date: false,
      error: null,
      schoolchild_age: 0,
      simplified: false,
      selectors: {
        olympiads: [],
      },
      rules: {
        name: value => {
          if (value !== undefined) {
            const pattern = /^[а-яёА-ЯЁ]+(?:[-/][а-яёА-ЯЁ]+)*$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Обязательное поле'
          }
        },
        middle_name: value => {
          if (value !== '') {
            const pattern = /^[а-яёА-ЯЁ]+(?:[-/][а-яёА-ЯЁ]+)*$/
            return pattern.test(value) || 'Некорректный ввод'
          }
        },
        phone: value => {
          if (value !== '') {
            const pattern = /^\+7[ ]\(\d{3}\)[ ]\d{3}-\d{2}-\d{2}$/
            return pattern.test(value) || 'Некорректный ввод'
          }
        },
        data: value => {
          if (value !== undefined) {
            const pattern = /^\d{4}-\d{2}-\d{2}$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Обязательное поле'
          }
        },
        not_null: value => {
          if (value !== undefined && value !== null) {
            if (typeof value === "string") {
              return value.trim().length > 0 || 'Поле не может быть пустым'
            } else {
              return value || 'Поле не может быть пустым'
            }
          } else {
            return 'Обязательное поле'
          }
        },
        email: value => {
          if (value !== null) {
            const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Введите адрес Вашей электронной почты'
          }
        },
        file: value => {
          if (value !== undefined && value !== null && value.length > 0) {
            return !value || !value.length || value[0].size < 5000000 || 'Файл больше 5 мб.'
          } else {
            return 'Обязательное поле'
          }
        },
        number: value => {
          if (value !== '') {
            return (value >= 9 && value <= 11) || 'Некорректный ввод'
          } else {
            return 'Обязательное поле'
          }
        },
      }
    }
  },
  watch: {
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
        this.error = null
      },
      deep: true
    },
    'data.class_name': {
      handler: function () {
        this.data.olympiad = null
        this.loadSelectors(this.data.class_name)
      },
      deep: true
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
      getPreviousMembers: 'personal_account/members/getPreviousMembers'
    })
  },
  methods: {
    ...mapActions({
      createSchoolchild: 'personal_account/members/schoolchild/createSchoolchild',
      simplifiedCreateSchoolchild: 'personal_account/members/schoolchild/simplifiedCreateSchoolchild',
      loadMembers: 'personal_account/members/loadMembers',
      loadPreviousMembers: 'personal_account/members/loadPreviousMembers',
      loadOlympiads: 'selectors/loadOlympiads',
    }),
    calculateAge (birth) {
      const currentDate = new Date()
      const birthDate = new Date(birth)
      const birthYear = birthDate.getFullYear()
      const birthMonth = birthDate.getMonth()
      const birthDay = birthDate.getDate()

      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth()
      const currentDay = currentDate.getDate()

      let age = currentYear - birthYear
      // Проверяем, достигли ли уже дня рождения в текущем году
      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        age--
      }

      return age
    },
    loadSelectors (class_name = 9) {
      this.loadOlympiads({
        url: undefined,
        params: { level: class_name, is_grant: false },
        finalizer: (val) => {
          this.selectors.olympiads = val
        }
      })
    },
    loadData (url = undefined) {
      this.loadPreviousMembers({
        url: url,
        finalizer: (data) => {
          this.putDataInFields(data)
        },
        catcher: () => {
          this.$router.push({ name: names.REGISTRATION.PAGE })
        }
      })
    },
    putDataInFields (data) {
      if (data?.member_request === undefined || data?.member_request === null) {
        return null
      }
      if (data.member_request.type === "schoolchild") {
        for (const key of Object.keys(data.member_request)) {
          // eslint-disable-next-line
          if (this.data.hasOwnProperty(key)) {
            if (key === 'olympiad') {
              this.data.olympiad = data.member_request.olympiad.id
            } else {
              this.data[key] = data.member_request[key]
            }
          }
        }
      }
    },
    loadMemberData (url = undefined) {
      this.loadMembers({
        url: url,
        finalizer: (data) => {
          this.schoolchild_age = this.calculateAge(data.birth)
        },
        catcher: () => {
          this.$router.push({ name: names.REGISTRATION.PAGE })
        }
      })
    },
    endRedirect () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: names.REGISTRATION_APPROVE.PAGE })
    },
    async validate () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.sendCreateSchoolchild()
      }
    },
    sendCreateSchoolchild: function () {
      this.loading = true
      this.error = null

      const formData = new FormData()
      for (const key of Object.keys(this.data)) {
        if (key === "file1") {
          if (this.data[key]) {
            formData.append('files', this.data[key][0], this.data[key][0].name)
            formData.append('names', `Паспорт_${this.data[key][0].name}`)
            formData.append('types', 'Паспорт')
          }
        } else if (key === "file2") {
          if (this.data[key]) {
            formData.append('files', this.data[key][0], this.data[key][0].name)
            formData.append('names', `Диплом_${this.data[key][0].name}`)
            formData.append('types', 'Диплом')
          }
        } else {
          if (this.data[key]) { formData.append(key, this.data[key]) }
        }
      }

      if (this.simplified) {
        this.simplifiedCreateSchoolchild(
          {
            data: formData,
            finalizer: () => {
              this.loading = false
              this.error = null
              this.endRedirect()
            },
            catcher: (error) => {
              this.loading = false
              if (error.member) {
                this.error = error.member
              } else if (error.detail) {
                this.error = error.detail
              } else if (error.files === "Ensure this field has at least 2 elements.") {
                error.files = 'Вы прикрепили не все требуемые файлы.'
                this.mapErrors(error)
              } else {
                this.mapErrors(error)
              }
            }
          }
        )
      } else {
        this.createSchoolchild(
          {
            data: formData,
            finalizer: () => {
              this.loading = false
              this.error = null
              this.endRedirect()
            },
            catcher: (error) => {
              this.loading = false
              if (error.member) {
                this.error = error.member
              } else if (error.detail) {
                this.error = error.detail
              } else if (error.files === "Ensure this field has at least 2 elements.") {
                error.files = 'Вы прикрепили не все требуемые файлы.'
                this.mapErrors(error)
              } else {
                this.mapErrors(error)
              }
            }
          }
        )
      }
    },
  },
  created () {
    if (this.getUserStatus.special_information) {
      this.$router.push({ name: pa_names.MAIN })
    } else {
      // eslint-disable-next-line
      this.loadMemberData()
      if (this.getUserStatus.has_previous) {
        if (this.getPreviousMembers === null) {
          this.loadData()
        } else {
          this.putDataInFields(this.getPreviousMembers)
        }
      }
      if (this.$route.query.simplified) {
        this.simplified = true
      }
      if (this.selectors.olympiads.length === 0) {
        this.loadSelectors()
      }
    }
  },
})
</script>

<style scoped lang="scss">
.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.page__sub_subtitle {
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 35px;
  text-align: center;

  color: #3254B9;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  width: 500px;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 50px;
  width: 200px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.file__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1440px;
}

.file__input {
  margin: 0 auto 40px;
  width: 100%;
}

.file_label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.file__input_row {
  width: 100%;

  &:first-child {
    margin-bottom: 30px;
  }
}

.file__container > .v-input--density-default {
  --v-input-control-height: 300px;
}

.file__container > .v-input > .v-input__control > .v-field--active {
  .file__input_row {
    &:first-child {
      display: none;
    }
  }

  .file_label__text {
    color: currentColor;
  }
}

.check_box__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

.check__box {
  margin: -10px 0 -10px 0px;
  width: 100%;
  color: #313743;
}

.check__box_text {
  padding-left: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: inline-block;
  align-items: center;
  text-align: left;
  color: #313743;
}

.alert__container {
  justify-content: center;
  align-items: center;
  margin: 0 auto 10px;
  width: 100%;
  max-width: 500px;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1440px) {
  .file__container {
    width: 1200px;
  }
}

@media screen and (max-width: 1279px) {
  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }

  .page__sub_subtitle {
    font-size: 20px;
    line-height: 27px;
    padding: 0 20px;
  }

  .file__container {
    width: 600px;
  }
}

@media screen and (max-width: 768px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .page__sub_subtitle {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 19px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }

  .file__container {
    width: 500px;
  }

  .check__box_text {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }

  .file_label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .file__container > .v-input--density-default {
    --v-input-control-height: 200px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }

  .file__container {
    width: 300px;
  }
}

@media screen and (max-width: 300px) {
  .file__container {
    width: 270px;
  }
}
</style>
